import { proxy } from "valtio";
import { TBusinessSchema, TPersonalSchema, TIdSchema } from "@/features/auth/forms/schema";


export type RegistrationStore = {
    personal?: TPersonalSchema
    business?: TBusinessSchema
    identification?: TIdSchema,
    token?: string
    setToken: (value: string) => void
    setPersonal: (value: TPersonalSchema) => void
    setBusiness: (value: TBusinessSchema) => void
    setIdentification: (value: TIdSchema) => void
}

export const registrationStore = proxy<RegistrationStore>({
    personal: undefined, 
    business: undefined,
    identification: undefined,
    token: undefined,

    setPersonal: (value: TPersonalSchema) => {
        registrationStore.personal = value
    },

    setBusiness: (value: TBusinessSchema) => {
        registrationStore.business = value
    },

    setIdentification: (value: TIdSchema) => {
        registrationStore.identification = value
    },

    setToken: (value: string) => {
        registrationStore.token = value;
    }
});